module.exports = __webpack_public_path__ + "static/media/get-started-1-4.88246fe6.svg";